class DesignDiamond extends HTMLElement{
    constructor(){
        super()
        this.closeBtn = this.querySelector('.design-diamond-popup--close')
        this.closeBtn.addEventListener('click',this.handleCloseBtn.bind(this))
        this.template = JSON.parse(this.querySelector('#diamondPopupTemplate').textContent)
        this.timeOut = parseInt(JSON.parse(this.querySelector('#diamondPopupTime').textContent)) * 1000
        this.handleTemplate()
    }
    handleCloseBtn(){
        this.classList.add('hidden')
    }
    handleTemplate(){
        if(this.template == 'design-your-engagement-ring'){
            setTimeout(function(){
                this.classList.remove('hidden')
            }.bind(this), this.timeOut)
        }
    }
}

customElements.define('design-diamond-popup', DesignDiamond)